import React, { useState } from 'react';
import { Tooltip, Button } from '@material-ui/core';
import { borderColor } from './common';
import * as getStatus from '~/skills/getStatus';

import EAA_Date from './EAA_Date';
import EAA_Time from './EAA_Time';
import EAA_Input from './EAA_Input';
import EAA_Memo from './EAA_Memo';
import EAA_Select from './EAA_Select';
import EAA_Btn from './EAA_Btn';
import EAA_Upload from './EAA_Upload';
import EAA_BottomBtn from './EAA_BottomBtn';

const EAA_TitleText = ({
  text = '',
  bol = false,
  haveChange = false,
  width = 100,
  subtitle = null,
  fontSize = 16,
  fontWeight = 500,
  subtitleColor = '#064B6F',
  onClick = null,
  tooltip = '',
  titleAry = [],
}) => (
  <div style={{ marginRight: 20, fontSize, fontWeight, userSelect: 'none' }}>
    {onClick && (
      <Tooltip title={tooltip} placement='bottom-end'>
        <div style={{ display: 'flex', width, flexDirection: 'row', color: haveChange ? 'red' : 'blue', textDecoration: 'underline', cursor: 'pointer' }}>
          {bol && <div style={{ color: 'red' }}>*</div>}
          <div onClick={onClick} style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{text}</div>
        </div>
      </Tooltip>
    )}
    {!onClick && (
      <div style={{ display: 'flex', width, flexDirection: 'row', color: haveChange ? 'red' : 'black' }}>
        {bol && <div style={{ color: 'red' }}>*</div>}
        <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{text}</div>
      </div>
    )}
    <div style={{ display: 'flex', color: haveChange ? 'red' : subtitleColor, flexDirection: 'row', marginLeft: bol ? 8 : 0 }}>
      {subtitle}
    </div>
    {titleAry.map((o, i) => (
      <div key={i} style={{ display: 'flex', color: haveChange ? 'red' : (o.color || subtitleColor), flexDirection: 'row', marginLeft: bol ? 8 : 0 }}>
        {o.title}
      </div>
    ))}
  </div>
);

const EAA_ItemContainer = ({ children = null }) => (
  <div style={{ flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
    {children}
  </div>
);

const EAA_Row = ({ children = null, style = {} }) => (
  <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginTop: 16, alignItems: 'center', ...style }}>
    {children}
  </div>
);

const EAA_ErrorText = ({ text = '', marginLeft = 120 }) => (
  <div style={{ color: 'red', fontSize: 16, textAlign: 'start', marginLeft, marginTop: 4 }}>
    {text}
  </div>
);
const EAA_Item = ({ children = null, style = {} }) => (
  <div style={{ flex: 1, display: 'flex', flexDirection: 'column', ...style }}>
    {children}
  </div>
);

const EAA_Add_Btn = ({ onClick = () => {}, style = {}, marginRight = 50, del = false, text = null, disabled }) => {
  const [over, setOver] = useState(false);
  const color = disabled ? 'gray' : (over ? 'black' : (del ? 'red' : '#5597b4'));
  const t = text || (del ? '刪除一筆' : '新增一筆');
  const backgroundColor = (disabled || over) ? '#d8d8d8' : 'white';
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      style={{
        width: 100,
        height: 39,
        border: `2px solid ${color}`,
        fontSize: 16,
        color,
        borderRadius: 50,
        marginRight,
        backgroundColor,
        ...style,
      }}
      onMouseOver={() => disabled ? null : setOver(true)}
      onMouseOut={() => disabled ? null : setOver(false)}
    >
      {t}
    </Button>
  );
};
const EAA_ExcelDownload = ({ onClick = () => {}, style = {}, disabled = false }) => {
  const [over, setOver] = useState(false);
  return (
    <div
      style={{
        color: disabled ? 'gray' : (over ? 'blue' : '#01958E'),
        fontSize: 16,
        fontWeight: 500,
        cursor: disabled ? 'default' : 'pointer',
        textDecorationLine: 'underline',
        userSelect: 'none',
        ...style,
      }}
      onMouseOver={() => setOver(true)}
      onMouseOut={() => setOver(false)}
      onClick={disabled ? () => {} : onClick}
    >
      Excel範例下載
    </div>
  );
};

const EAA_Area = ({ children = null, title = '', color = '#5597B4', backgroundColor = '#EBF3F5', titleItem = null, style = {} }) => [
  title.length > 0 || titleItem
    ? (
      <div key='title' style={{ color, fontSize: 20, fontWeight: 700, marginLeft: 28, marginTop: 12, display: 'flex', alignItems: 'center', ...style }}>
        {title}
        {titleItem}
      </div>
    )
    : null,
  <div key='EAA_Area' style={{ width: '100%', backgroundColor, borderRadius: 10, marginTop: 5, ...style }}>
    <div style={{ padding: 26 }}>
      {children}
    </div>
  </div>,
];

const EAA_UpdateTime = ({ data = {} }) => !data.upd_time
  ? null
  : (
    <EAA_Row>
      <EAA_ItemContainer>
        <EAA_TitleText width={120} text='上次更新時間' />
        <div>{data.upd_time}</div>
      </EAA_ItemContainer>
    </EAA_Row>
  );

const EAA_Status = ({ data = {} }) => (
  <EAA_Row>
    <EAA_ItemContainer>
      <EAA_TitleText width={120} fontSize={20} fontWeight={700} text='表單目前狀態' />
      <div style={{ color: '#2F80ED', fontSize: 20, fontWeight: 700 }}>{getStatus.form(data)}</div>
    </EAA_ItemContainer>
  </EAA_Row>
);

export {
  EAA_Date,
  EAA_ErrorText,
  EAA_Item,
  EAA_ItemContainer,
  EAA_Memo,
  EAA_Row,
  EAA_Select,
  EAA_TitleText,
  EAA_Input,
  EAA_Btn,
  EAA_Time,
  EAA_Upload,
  EAA_Add_Btn,
  EAA_ExcelDownload,
  EAA_Area,
  EAA_UpdateTime,
  EAA_Status,
  EAA_BottomBtn,
};
